import { call, delay, put, race, take } from 'redux-saga/effects'
import { fetchProductEligibility } from 'services/api/elegible'
import { Response } from 'utils/fetchApi'

import { actions } from './slice'
import { ProductEligibility } from './types'

const POLLING_DELAY = 10000

const fetchSaga = function* () {
  while (true) {
    const res: Response<ProductEligibility> = yield call(fetchProductEligibility)
    if (res.ok) {
      yield put(actions.setEligibility(res.response))
      yield delay(POLLING_DELAY)
    } else {
      yield take(actions.stopPolling.type)
      yield put(actions.error())
    }
  }
}

function* pollSagaWatcher() {
  yield take(actions.startPolling.type)
  yield race([call(fetchSaga), take(actions.stopPolling.type)])
}

export default pollSagaWatcher
